export default __webpack_public_path__ + "assets/images/aistudio/59e293f11533d600cc50d102650e48e6.png";